import firebase from 'firebase/app'

export default class InputFile {
  constructor(file) {
    this.file = file
    this.uploadFile = ''
  }

  async upload() {
    try {
      const storage = firebase.storage()
      /* eslint-disable prefer-template */
      const storageRef = await storage.ref('articles/' + this.file.name)
      /* eslint-enable */
      await storageRef.put(this.file)
      this.uploadFile = await storageRef.getDownloadURL()

      const response = {
        data: this.uploadFile,
      }
      return response
    } catch (error) {
      window.console.log('error', error)
      const response = {
        msg: error,
      }
      return response
    }
  }
}
